<template>
  <div>
    <div v-if="currentIconSet" class="icon-select-container">
      <div class="content">
        <div>
          <div class="word-container md:md-word-container">
            {{ currentIconSet.word }}
          </div>
          <div class="instruction">
            Choose the icon that best represents '{{ currentIconSet.word }}' for you.
          </div>
          <div class="grid grid-cols-3">
            <div
              v-for="icon in currentIconSet.icons"
              :key="icon.id"
              v-on:click="selectIcon(icon.id, icon.pngPath)"
              class="icon-container"
            >
              <img class="icon" :src="icon.pngPath"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="text-container md:md-text-container">
        <div class="grid grid-cols-1 md:grid-cols-10 gap-5">
          <div class="md:col-span-8">
            <Heading text="Your chosen icons"/>
          </div>
          <div class="md:col-span-10">
            <div class="grid grid-cols-3 image-grid md:md-image-grid">
              <div
                v-for="image in selectedImages"
                :key="image"
                class="image-container"
              >
                <img class="icon-image" :src="image"/>
              </div>
            </div>
          </div>
          <div class="md:col-span-10">
            <Button v-bind:onClick="nextPage" text="Continue" :noMargin="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Button from '@/components/Button.vue';
import Heading from '@/components/Heading.vue';

export default {
  name: 'IconSelect',
  components: {
    Button,
    Heading,
  },
  data() {
    return {
      currentIconSet: null,
      remainingIconSets: this.$store.state.iconOptions,
      selectedImages: [],
      selections: [],
    };
  },
  methods: {
    nextPage() {
      this.$store.commit('setView', 'MemeSelect');
    },
    setCurrentIconSet() {
      [this.currentIconSet] = this.remainingIconSets;
      this.remainingIconSets.shift();
    },
    selectIcon(id, imagePath) {
      this.selections.push({
        icon_options: this.currentIconSet.id,
        selected_icon: id,
      });

      this.selectedImages.push(imagePath);

      if (this.remainingIconSets.length) {
        this.setCurrentIconSet();
      } else {
        this.currentIconSet = null;
        this.submitIcons();
      }
    },
    submitIcons() {
      axios
        .post(
          `${process.env.VUE_APP_BACKEND_URL}/api/sessions/submit-icons/`,
          {
            uuid: this.$store.state.sessionId,
            icon_choices: this.selections,
          },
        )
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.setCurrentIconSet();
  },
};
</script>

<style scoped>
.content {
  align-self: center;
  width: 100%
}

.icon {
  max-height: 25vw;
  width: auto;
}

.icon-container {
  display: flex;
  justify-content: center;
}

.icon-image {
  margin: 10%;
  max-height: 25vh;
  width: auto;
}

.icon-select-container {
  align-content: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  margin: auto;
  width: 100vw;
}

.image-container {
  display: flex;
}

.image-grid {
  margin: auto;
}

.instruction {
  margin-bottom: 2em;
}

.summary-container {
  margin: auto;
  margin-top: 50px;
  max-width: 90vw;
}

.title {
  color: #9a9899;
  font-weight: bold;
}

.word-container {
  color: #9a9899;
  font-size: 2em;
  font-weight: bold;
  text-transform: uppercase;
}

@responsive {
  .md-image-grid {
    width: 50vw;
  }

  .md-summary-container {
    margin-top: 8vh;
    max-width: 70vw;
    text-align: left;
  }

  .md-word-container {
    font-size: 1.3em;
  }
}
</style>
